export default String.raw`
.companies {
    padding: 0 5%;
    
    &__header {
        h2 {
            @include h3-headline;
        }
    }

    &__prev, &__next {
        visibility: hidden;
    }

    &__swiper {
        overflow-x: visible;

        .swiper-button-pause {
            top: -52px;
            box-shadow: unset;
        }
    }

    &__slide {
        width: calc(100% / 2.5);
    }
}
`